// React things
import React, { useEffect, useState } from 'react';

export default function ComponentWrapper(props){
  useEffect(()=>{
  },[])
  return(
    <>
        {React.Children.map(props.children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { 'setLoading': props.setLoading });
                }
                return child;
            }
        )}
    </>
  )
}